import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Classical_Antiquity_-_Han_Dynasty_China.png';

function HistoryPageHanGo() {
  return (
    <QuizPage
      title="History: Han Dynasty (China)"
      subTopic="Han Dynasty (China)"
      backgroundImage={historyImage}
      returnPath="/History-Han-Dynasty"
    />
  );
}

export default HistoryPageHanGo;   

